<template>
	<div class="card">
        <div class="card-header">
            <div class="row">
	            <div class="d-flex justify-content-between container-fluid">
			        <div class="text-muted fs-19 d-flex justify-content-start">
			            <strong>Despesa</strong>
			            <slot></slot>
			        </div>
					<bsh-dropdown-nav
				  		id="despesaNav"
				  		:tabs="tabs"
				  		:ativo="2"
				  		@navChanged="ChangeChart">
				  	</bsh-dropdown-nav>
				</div>
            </div>
        </div>
        <div class="card-body">
			<chart  
				:data="config.data"
				identify="chartDespesa"
				width="100%"
				height="40"
				:key="chartKey">
			</chart>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['date'],
		data(){
			return {
				dados: [],
				label: [],
				datasets: [],
				tabs: [
		            {
		              	label: 'Semana',
		              	field: 'semana',
		            },
		            {
		              	label: 'Mês',
		              	field: 'mes'
		            },
		            {
		            	label: 'Ano',
		              	field: 'ano',
		            },
				],
				config: {
					'data': [] 
				},
				chartKey: 1
			}
		},
		created(){
			this.getDados();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/despesas/chart?data='+this.date)
	            .then(response => {
	            	this.dados = response.data
					this.ChangeChart('ano')
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
			ChangeChart(chartPeriod){
				this.datasets = [];
				if(chartPeriod == 'ano'){
					this.label = this.setLabelAno();
					this.datasets.push(this.dados.despesa_mes_ano);
				}
				if(chartPeriod == 'mes'){
					this.label = this.setLabelMes();
					this.datasets.push(this.dados.despesa_dia_mes);
				}
				if(chartPeriod == 'semana'){
					this.label = this.setLabelSemana();
					this.datasets.push(this.dados.despesa_dia_semana);
				}
				this.setConfigData();
				this.chartKey += 1;
			},
			setLabelMes(){
				var date = new Date();
				var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
				var dia_fim = ultimoDia.getDate();
				var result = [];
				for(var i=1; i<=dia_fim; i++){
					result.push(String(i));
				}	
				return result;
			},
			setLabelAno(){
				return [
					'Jan',
					'Fev',
					'Mar',
					'Abr',
					'Mai',
					'Jun',
					'Jul',
					'Ago',
					'Set',
					'Out',
					'Nov',
					'Dez'
				];
			},
			setLabelSemana(){
				return [
					'Dom',
					'Seg',
					'Ter',
					'Qua',
					'Qui',
					'Sex',
					'Sab'
				];
			},
			setConfigData(){
				this.config['data'] = {
				 	type: 'bar',
				  	data: {
				    	labels: this.label,
				    	datasets: this.datasets
				  	},
				  	options: {
				    	scales: {
				      		xAxes: [
				      			{
				        			time: {
				          				unit: 'date'
				        			},
				        			gridLines: {
				          				display: false
				        			},
				        			ticks: {
				          				maxTicksLimit: 32
				        			}
				      			}
				      		],
				      		yAxes: [{
				        		ticks: {
				          			min: 0,
				          			maxTicksLimit: 5,
				          			callback: function(value) {
									    return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
									}
				        		},
				        		gridLines: {
				          			color: "rgba(0, 0, 0, .125)",
				        		}
				      		}],
				    	},
				    	legend: {
				      		display: false
				    	},
				    	tooltips: {
							callbacks: {
								label: function(tooltipItem, data) {
							    	return tooltipItem.yLabel.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
							  	}
							}
						}
				  	}
				}
			}
		}
	}
</script>